import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';

import wrapWithCustomControl from 'layouts/CustomControlLayout/CustomControlWrapperLayout';
import CustomControlWrapper from 'layouts/CustomControlLayout/CustomControlWrapper';

import SelectListWithKeySupport from 'components/SelectList/SelectListWithKeySupport';
import SearchUnitHotelName from 'components/SearchUnitHotelName/SearchUnitHotelName';

import { debounce, isDomainIe, updateWindowLocation } from 'utils/utils';

import * as appStateActions from 'actions/appStateActions';
import * as searchUnitActions from 'actions/searchUnitActions';

import './SearchUnitHotelNameLayout.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  appState: state.appState,
  search: state.search,
});

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    appStateActionsBound: bindActionCreators(appStateActions, dispatch),
    searchUnitActionsBound: bindActionCreators(searchUnitActions, dispatch),
  };
}

export class SearchUnitHotelNameLayout extends Component {
  static propTypes = {
    appState: PropTypes.instanceOf(Immutable.Map).isRequired,
    appStateActionsBound: PropTypes.shape({
      setHasNoHotelResults: PropTypes.func.isRequired,
      setHotelQuery: PropTypes.func.isRequired,
    }).isRequired,
    hideCustomControl: PropTypes.func.isRequired,
    isCustomControlVisible: PropTypes.bool.isRequired,
    search: PropTypes.instanceOf(Immutable.List),
    searchUnitActionsBound: PropTypes.shape({
      suggestHotels: PropTypes.func.isRequired,
    }).isRequired,
    showCustomControl: PropTypes.func.isRequired,
  };

  static defaultProps = {
    search: [],
  };

  getHotelItem(suggestion) {
    return {
      name: `<b>${suggestion.get('label')}</b>, in ${suggestion.get('location')}`,
      value: suggestion.get('dimensionValueId'),
      href: suggestion.get('detailURL'),
      contentType: suggestion.get('type'),
    };
  }

  isMobile() {
    return this.props.appState.get('isMobileBreakpoint');
  }

  get suggestedHotels() {
    const { search } = this.props;
    return search.toArray().map(suggestion => this.getHotelItem(suggestion));
  }

  getSuggestions = () => {
    const {
      appStateActionsBound,
      searchUnitActionsBound,
      showCustomControl,
    } = this.props;

    if (this.userTextInput && this.userTextInput.length > 1) {
      const params = {
        query: this.userTextInput,
        rows: this.isMobile() ? 5 : 10,
      };

      if (isDomainIe()) {
        params.filterQuery = 'locale:en-IE';
      }

      searchUnitActionsBound.suggestHotels(params).then(showCustomControl);
    } else {
      appStateActionsBound.setHasNoHotelResults(false);
    }
  }

  saveSelectListRef = (ref) => {
    this.selectListRef = ref;
  };

  getSuggestionsDebounced = debounce(this.getSuggestions, 400);

  onInputChange = (event, elementRef) => {
    const { appStateActionsBound } = this.props;

    appStateActionsBound.setHotelQuery(event.currentTarget.value);
    this.userTextInput = event.currentTarget.value;
    this.hotelElementRef = elementRef;
    this.getSuggestionsDebounced();
  }

  onKeyDown = (event) => {
    const arrowUpKeyCode = 38;
    const arrowDownKeyCode = 40;
    const enterKeyCode = 13;
    const tabKeyCode = 9;

    if (this.selectListRef) {
      if (event.keyCode === arrowUpKeyCode) {
        this.selectListRef.selectPrevious();
        event.preventDefault();
      } else if (event.keyCode === arrowDownKeyCode) {
        this.selectListRef.selectNext();
        event.preventDefault();
      } else if (event.keyCode === tabKeyCode || event.keyCode === enterKeyCode) {
        this.enterUrl();
      }
    }
  }

  enterUrl() {
    const activeIndex = this.selectListRef.state.activeIndex;
    const url = this.props.search.getIn([`${activeIndex}`, 'detailURL']);
    updateWindowLocation(url);
  }

  render() {
    const { appState, hideCustomControl } = this.props;
    return (
      <div className="search-unit-hotel-layout" onKeyDown={this.onKeyDown}>
        <SearchUnitHotelName
          onInputChange={this.onInputChange}
          queryValue={appState.get('hotelQuery')}
        />
        { this.props.isCustomControlVisible && (
          <CustomControlWrapper closeCustomControl={hideCustomControl}>
            <div className="search-unit-hotel-layout__select">
              <SelectListWithKeySupport
                ref={this.saveSelectListRef}
                controlPosition="left"
                emptyElementsMessage="No matches found"
                type="empty"
                elements={this.suggestedHotels}
                appState={appState}
              />
            </div>
          </CustomControlWrapper>
        ) }
      </div>
    );
  }
}

export default wrapWithCustomControl(connect(mapStateToProps, mapDispatchToProps)(SearchUnitHotelNameLayout));



/** WEBPACK FOOTER **
 ** ./src/layouts/SearchUnitHotelNameLayout/SearchUnitHotelNameLayout.jsx
 **/